export default "__VITE_ASSET__Cl_bOOJD__";